import config from "../Util/config";
import axios from "axios";
import jwt from "jwt-decode";
import URLconfig from "./URLConfig";

const uninterceptedAxiosInstance = axios.create();

axios.interceptors.request.use((req) => {
  //console.log("Ysta dah el interceptor yalaaaaaa",`${req.method} ${req.url}`);
  getCurrentUser();
  return req;
});

const checkLoggedIn = async () => {
  if (await localStorage.getItem("accessToken")) {
    //console.log("eshta allah yenwar sh8ala")
    return true;
  }
  {
    //console.log("el function m4 sh8ala ")
    return false;
  }
};

const getUserType = async () => {
  const userToken = localStorage.getItem("accessToken");
  if (userToken) {
    //console.log("el User Type hna (",jwt(userToken).RoleName,")")
    return jwt(userToken).RoleName;
  } else throw new Error("Error getting user type");
};

const login = async ({ username, password }) => {
  try {
    const response = await axios.post(
      `${URLconfig.API_BASE_URL}api/auth/authenticate`,
      {
        username: username,
        password: password,
      },
      {}
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getCurrentUser = () => {
  try {
    const userToken = localStorage.getItem("accessToken");
    const decodedToken = jwt(userToken);
    if (decodedToken && Date.now() >= decodedToken.exp * 1000) {
      return TokenExpired();
    }
    return decodedToken;
  } catch (ex) {
    //console.log("Failed to decode the token", ex)
    return null;
  }
};

const getToken = () => {
  return localStorage.getItem("accessToken");
};

const saveTokenToLocalStorage = (token) => {
  //console.log("Saving token to local storage", token)
  localStorage.setItem("accessToken", token);
};

const deleteTokenFromLocalStorage = () => {
  localStorage.removeItem("accessToken");
  alert("Signed Out Successfully");
};

const TokenExpired = () => {
  localStorage.removeItem("accessToken");
  alert("Your Session Expired, Please Login Again");
  window.location.replace("/policies/#/login");
};

export {
  login,
  saveTokenToLocalStorage,
  deleteTokenFromLocalStorage,
  getToken,
  getCurrentUser,
  checkLoggedIn,
  getUserType,
};
